import actions from './actions'

const initialState = {
  id: null,
  schoolName: null,
  loading: false,
  updateMlLoading: false,
}

export default function schoolReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
